module.exports = __webpack_public_path__ + "public/img/word-04.f4ec2aea.svg";